export default "<section>\n  <div class=\"ticket-table\" ng-include=\"vm.templateUrl\"></div>\n</section>\n";